const sessionManagementTypes = {
    ACTIVE: 'ACTIVE',
    REVOKED: 'REVOKED',
    UNKNOWN: 'UNKNOWN',
};

export default sessionManagementTypes;
